import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigService } from './config.service';
import { Token } from './token.model';

@Injectable()
export class TokenRepository {

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }

  public refresh(refreshToken: string): Observable<Token> {
    return this.http.post(
        this.config.getRefreshTokenApiUrl(),
        { refresh_token: refreshToken }
      )
      .pipe(
        map((tokenData: any): Token =>
          new Token(tokenData.token, tokenData.refresh_token)
        )
      );
  }

  public canRefresh(): boolean {
    const refreshTokenApiUrl = this.config.getRefreshTokenApiUrl();

    return (
        'string' === typeof refreshTokenApiUrl &&
        '' !== refreshTokenApiUrl
      );
  }

}
